require("./submodules/ry-tooltip/ry-tooltip.js")
require("./submodules/flatpickr/flatpickr.js")
require("./submodules/chart.js/chart.js")
require("./submodules/monaco/monaco.js")
require("./submodules/ry-modal/ry-modal.js")

require("./bahabot.module.js")

require("./pipes/bb-text-bool.pipe.js")
require("./pipes/bb-date.pipe.js")
require("./pipes/bb-execution-status.pipe.js")

require("./services/auth.service.js")
require("./services/layout.service.js")
require("./services/theme.service.js")
require("./services/account.service.js")
require("./services/setting.service.js")
require("./services/activity.service.js")
require("./services/dashboard.service.js")
require("./services/command.service.js")
require("./services/command-group.service.js")
require("./services/command-group-assignment.service.js")
require("./services/command-execution.service.js")
require("./services/command-execution-log.service.js")
require("./services/command-test.service.js")
require("./services/word.service.js")
require("./services/badword.service.js")
require("./services/eventsource.service.js")
require("./services/context-menu.service.js")
require("./services/tagged-messages.service.js")
require("./services/discord.service.js")

require("./layouts/bb-layout.layout.js")
require("./layouts/bb-login.layout.js")
require("./layouts/bb-dashboard.layout.js")

require("./components/pages/bb-docs.component.js")
require("./components/pages/bb-login.component.js")
require("./components/pages/bb-accounts.component.js")
require("./components/pages/bb-settings.component.js")
require("./components/pages/bb-activities.component.js")
require("./components/pages/bb-dashboard.component.js")
require("./components/pages/bb-commands.component.js")
require("./components/pages/bb-commands-editor.component.js")
require("./components/pages/bb-command-executions.component.js")
require("./components/pages/bb-command-execution-logs.component.js")
require("./components/pages/bb-command-status.component.js")
require("./components/pages/bb-badwords.component.js")
require("./components/pages/bb-words.component.js")
require("./components/pages/bb-tagged-messages.component.js")
require("./components/pages/bb-chat.component.js")
require("./components/pages/bb-logs.component.js")
require("./components/pages/bb-discord.component.js")

require("./components/contextmenu/bb-context-menu.component.js")

require("./components/input/bb-chips-input.component.js")
require("./components/input/bb-discord-resource-input.component.js")
require("./components/input/bb-discord-role-picker.component.js")
require("./components/input/bb-input.component.js")

require("./directives/validation/bb-invalid-if.directive.js")
require("./directives/contextmenu/ng-contextmenu.directive.js")

